import { AccountApiKeysRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/api-keys')({
  component: AccountApiKeysRoute,
});
